module.exports = "https://static.wanderu.com/ui-react/_next/static/media/redBus.9c73c979.png";